"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// styles
// import './styles/dashboard.scss';
require("./styles/all.scss");
var controllers_1 = require("./controllers");
var services_1 = require("./services");
var routes_1 = __importDefault(require("./config/routes"));
var directives_1 = require("./directives");
/**
 * @ngdoc module
 * @module profumo.apps.dashboard
 * @name profumo.apps.dashboard
 * @packageName profumo.apps
 * @description A module that includes the dashboard component.
 */
angular.module('profumo.apps.dashboard', ['ui.router'])
    .controller('DashboardController', controllers_1.DashboardController)
    .service('_dashboard', services_1.DashboardService)
    .directive('map', directives_1.MapDirective)
    .config(routes_1.default);



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/dashboard/index.ts
// module id = 470
// module chunks = 0